module.exports = __webpack_public_path__ + "img/tutorial-01.f79bf4c9.jpg";